<div class="body">

    <mat-toolbar class="ams-toolbar">
        <mat-icon class="main-icon">edit</mat-icon>
        <span>
            {{data.headline? data.headline: 'Eingabe'}}
        </span>
        <span class="spacer"></span>
        <button mat-icon-button color="warn" (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </mat-toolbar>

    <div class="content">

        <mat-form-field class="width" appearance="outline">
            <mat-label>{{data.label? data.label: 'Term eingeben'}}</mat-label>
            <input [formControl]=formControl matInput />
            <button mat-icon-button matSuffix color="warn" [disabled]="!formControl.value" (click)="clear()">
                <mat-icon>clear</mat-icon>
            </button>
        </mat-form-field>

    </div>

    <div class="footer">

        <button mat-raised-button color="primary" (click)="confirm()">
            Speichern
        </button>

    </div>

</div>